let lang = {

	"profession": "Software Developer",
	"university": "Minas Gerais State University",
	"portfolio": "Portfolio"

};

export default lang;
